export const UPDATE_AREAS = 500
export const UPDATE_AREAS_MOBILE = 800
export const DISTANCE_SYMMETRY = 0.004
